export class PointPerformanceLimitExceeded extends Error {
  constructor(message) {
    super(message);
    this.name = 'PointPerformanceLimitExceeded';
  }
}
